// extracted by mini-css-extract-plugin
export default {"TableContainer":"PurchaseIntentList_TableContainer__X5PpB"};